module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Shannon K. Butcher\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Shannon K. Butcher")]), _vm._v(" learned to write from her husband, bestselling author Jim Butcher, as she helped him with his stories.  Soon she found the idea of creating he own too compelling to resist and, after too many years working as an industrial engineer, gladly left that career to write full time.  Shannon lives in Missouri with her husband and son, where conversations at the dinner table are more often about fictional things than things that actually happened.  You can contact her at her website, "), _c('a', {
    attrs: {
      "href": "http://www.shannonkbutcher.com/"
    }
  }, [_vm._v("www.shannonkbutcher.com")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/EJolDv/images/NoControl-cover.jpg?1733067604672",
      "alt": "This image is the cover for the book No Control, Delta Force"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("No Control, Delta Force\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("NO HIDING. "), _c('br'), _c('br'), _vm._v(" Lana Hancock knows all about danger--and betrayal. Eighteen months ago, she was captured by a terrorist group known as the Swarm while one of its members, a rugged man with sinfully dark eyes, did nothing to help her. Now when she's freed and desperate to put it all behind her, the unthinkable happens. The Swarm is targeting Lana once again and the man who stood silently by has become her protector. But can she trust him? "), _c('br'), _c('br'), _vm._v(" NO ESCAPE. "), _c('br'), _c('br'), _vm._v(" Delta Force operative Caleb Stone will never forget the hatred shining in Lana's eyes.  Ordered to take down the Swarm by infiltrating its ranks, Caleb couldn't blow his cover to save her--no matter how much it haunted him. Now, gifted with a second chance, he vows to move heaven and earth to protect her...and fulfill her every desire.  But the Swarm has reorganized. It's more powerful than ever and hell-bent on revenge... "), _c('br'), _c('br'), _vm._v(" NO CONTROL.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Forever\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0